<template>
  <div class="service-container">
    <h1 class="service-title text_bold">您可以通过以下方式 联系九点半</h1>
    <div class="service-section">
      <div
        v-for="(service, index) in services"
        :key="index"
        :href="service.link"
        class="service-item"
        @mouseover="handleMouseOver(index)"
        @mouseleave="hoverIndex = null"
        @click="handleClick(index, service.link)"
      >
        <div class="icon">
          <img :src="hoverIndex === index ? service.hoverIcon : service.icon" :alt="service.title" />
        </div>
        <!-- <h3 class="title">{{ service.title }}</h3> -->
        <div v-if="index === 0" class="tooltip" v-show="hoverIndex === 0">
          TEL：400-0068-930
          <div class="arrow"></div>
        </div>
      </div>
    </div>
    <!-- 模态框 -->
    <div v-if="showQRCode" class="modal">
      <div class="modal-content">
        <span class="close" @click="showQRCode = false">&times;</span>
        <img :src="qrCodeImage" alt="企业二维码" class="qr-code-image" />
      </div>
    </div>
  </div>
  </template>
  
  <script>
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { imagePath } from '@/utils/imagePath';
    import erwei from '@/assets/images/erwei.png';
    import icons1 from '@/assets/images/fv/icons1.png';
    import icons2 from '@/assets/images/fv/icons2.png';
    import icons3 from '@/assets/images/fv/icons3.png';
    import icons4 from '@/assets/images/fv/icons4.png';
    import icons5 from '@/assets/images/fv/icons5.png';
    import icons6 from '@/assets/images/fv/icons6.png';
    
    export default {
      setup() {
        const hoverIndex = ref(null);
        const showQRCode = ref(false);
        const qrCodeImage = imagePath(erwei)  ; // 替换为你的二维码图片路径
    
        const services = [
          {
            title: '售前咨询',
            icon: 'https://wcdn.930pm.cn/images/icons1.png',
            hoverIcon: 'https://wcdn.930pm.cn/images/icons2.png',
            link: 'tel:400-0068-930'
          },
          {
            title: '售后服务',
            icon: 'https://wcdn.930pm.cn/images/icons3.png',
            hoverIcon: 'https://wcdn.930pm.cn/images/icons4.png',
            // link: 'https://example.com/after-sales'
          },
          {
            title: '成为代理商',
            icon: 'https://wcdn.930pm.cn/images/icons5.png',
            hoverIcon: 'https://wcdn.930pm.cn/images/icons6.png',
            link: '/toAgentRegister'
          }
        ];
    
        const router = useRouter();
    
        const toLink = (link) => {
          // 如果是内部路由，使用 router.push
          router.push(link);
        };
    
        const handleMouseOver = (index) => {
          hoverIndex.value = index;
        };
    
        const handleClick = (index, link) => {
          if (index === 0) {
            // 判断是否为移动设备
            if (/Mobi|Android/i.test(navigator.userAgent)) {
              // 移动端，直接拨打电话
              window.location.href = link;
            }
          } else if (index === 1) {
            // 第二个框，弹出企业二维码
            showQRCode.value = true;
          } else {
            // 如果是内部路由，使用 router.push
            router.push(link);
          }
        };
    
        return {
          services,
          hoverIndex,
          showQRCode,
          qrCodeImage,
          handleMouseOver,
          handleClick
        };
      }
    };
    </script>
  
  <style scoped>
    .service-container{
      padding: 60px 0;
    }
  .service-title{
      font-size: clamp(1.25rem, 2vw, 3rem);
      font-weight: bold;
      color: #1d1d1f;
      text-align: center;
      
  }
  .service-section {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 700px; /* PC端占60%宽度 */
    margin: 0 auto; /* 居中 */
    height: 180px;
    margin-top: 60px;
  }
  
  .service-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex: 1; /* 每个区域均分 */
    max-width: 180px; /* 可选：限制每个区域的最大宽度 */
    text-decoration: none; /* 移除链接下划线 */
    color: inherit; /* 继承父元素颜色 */
    transition: color 0.3s ease; /* 添加过渡效果 */
    position: relative;
  }
  .icon{
    width: 100%;
    height: 100%;
  }
  
  .icon img {
    width: 100%;
    height: 100%;
    /* margin-bottom: 10px; */
  }
  
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #000;
    transition: color 0.3s ease; /* 添加过渡效果 */
  }
  
  .service-item:hover .title {
    color: #007bff; /* 改变标题颜色 */
  }
  /* 气泡框样式 */
.tooltip {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 10;
  display: none; /* 默认隐藏 */
}
.tooltip .arrow {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
}
.service-item:hover .tooltip {
  display: block; /* 悬停时显示 */
}
  /* 模态框样式 */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
}
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}
.qr-code-image {
  max-width: 100%;
  height: auto;
}
  
  /* 移动端样式 */
  @media screen and (max-width: 768px) {
    .service-container{
      padding-top: 30px;
      padding-bottom: 0;
    }
    .service-section {
      width: 100%; /* 移动端占100%宽度 */
      height: 130px;
      margin-top: 0;
      padding: 0 20px;
    }
  
    .service-item {
      max-width: none; /* 移除最大宽度限制 */
    }
    /* .icon{ */
        /* width: 60%; */
        /* height: 40px;  */
    /* } */
    .icon img {
        width: 70%;
        /* height: 40px; */
        /* margin-bottom: 10px; */
    }
    .title{
        font-size: 16px;
    }
}
  </style>